import {
  Component, ErrorHandler,
} from '@angular/core';
import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import {AngularPlugin} from '@microsoft/applicationinsights-angularplugin-js';
import {environment} from '../environments/environment';
import {Router} from '@angular/router';
import { AppInsightsService } from './shared/utils/app-insights.service';
import { InvitationQueryParam } from './shared/models/queryParams';
import { LocalStorageKey } from './shared/models/localStorageKeys';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {

  constructor(
    router: Router,
    private appInsightsService: AppInsightsService
  ) {
    // Capture invitation IDs once at startup from the initial page URL.
    // This is synchronous and runs before Angular routing resolves, so it
    // reliably catches query params from invitation links. The IDs persist
    // in localStorage across the OAuth redirect cycle and are consumed by
    // BaseComponent.finalizeInvitationFlow() after authentication.
    const urlParams = new URLSearchParams(window.location.search);
    const combinedId = urlParams.get(InvitationQueryParam.COMBINED_CUSTOMER_USER_INVITATION_ID);
    if (combinedId) {
      localStorage.setItem(LocalStorageKey.COMBINED_CUSTOMER_USER_INVITATION_ID, combinedId);
    }
    const anonymousId = urlParams.get(InvitationQueryParam.ANONYMOUS_INVITATION_ID);
    if (anonymousId) {
      localStorage.setItem(LocalStorageKey.ANONYMOUS_INVITATION_ID, anonymousId);
    }

    this.customOfflinePage();
    this.initializeAppInsights(router);
  }

  private customOfflinePage() {
    self.addEventListener('fetch', function(event: any) {
      return event.respondWith(
        caches.match(event.request)
          .then(function(response) {
            const requestToCache = event.request.clone();

            return fetch(requestToCache).then().catch((error) => {
              console.error(error);
              // Check if the user is offline first and is trying to navigate to a web page
              if (event.request.method === 'GET' && event.request.headers.get('accept').includes('text/html')) {
                // Return the offline page
                return caches.match('/assets/offline.html');
              }
              return response;
            });
          })
      );
    });
  }

  private initializeAppInsights(router: Router) {
    if (environment.production || environment.uat) {
      const angularPlugin = new AngularPlugin();
      const appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: environment.appInsightsKey,
          extensions: [angularPlugin],
          extensionConfig: {
            [angularPlugin.identifier]: {
              router: router,
              errorServices: [new ErrorHandler()],
            }
          }
        }
      });

      appInsights.loadAppInsights();

      this.appInsightsService.init(appInsights);
    }
  }
}
